module.exports = __webpack_public_path__ + "img/pdqrcode.70861a09.png";